import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M13.3327 5L13.1057 4.09202C12.8269 2.977 12.6876 2.41949 12.291 2.07503C12.2471 2.03694 12.2013 2.00117 12.1537 1.96787C11.7234 1.66666 11.1487 1.66666 9.99935 1.66666C8.85001 1.66666 8.27534 1.66666 7.84498 1.96787C7.79739 2.00117 7.75158 2.03694 7.70773 2.07503C7.31114 2.41949 7.17177 2.977 6.89301 4.09202L6.66602 5",
      stroke: "white"
    }, null, -1),
    _createElementVNode("path", {
      d: "M6.66602 15L6.89301 15.908C7.17176 17.023 7.31114 17.5805 7.70773 17.925C7.75158 17.9631 7.79739 17.9988 7.84498 18.0321C8.27534 18.3333 8.85001 18.3333 9.99935 18.3333C11.1487 18.3333 11.7234 18.3333 12.1537 18.0321C12.2013 17.9988 12.2471 17.9631 12.291 17.925C12.6876 17.5805 12.8269 17.023 13.1057 15.908L13.3327 15",
      stroke: "white"
    }, null, -1),
    _createElementVNode("path", {
      d: "M10 8.33333V10.0042L10.8333 10.8333",
      stroke: "white",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("rect", {
      x: "5.5",
      y: "5",
      width: "9",
      height: "10",
      rx: "2",
      stroke: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }